import { Component, Input } from '@angular/core';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'cedatox-confirm-component',
  templateUrl: './cedatox-confirm.component.html',
  styleUrls: ['./cedatox-confirm.component.scss'],
})
export class CedatoXConfirmComponent {
  @Input() public data: any;

  constructor(
    public modalsService: ModalsService,
    public sharedService: SharedService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = { networkId: 0, networkName: '' };
  }

  confirm() {
    this.sharedService.sendMessage('CEDATOX_CONFIRM', true);
    this.modalsService.hideModal();
  }

  cancel() {
    this.sharedService.sendMessage('CEDATOX_CONFIRM', false);
    this.modalsService.hideModal();
  }
}
